import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { Address } from "./address"
import { IAddress } from "./address.types"
import { AccountDetailsAddress } from "@/api/backofficeRest/generated/model"

export interface IAddressRaw {
  countryCode: string
  postcode: string
  address1: string
  address2: string
  address3: string
}

export const AddressParser: IParser<IAddress, IAddressRaw> = {
  toDomain: (data: IAddressRaw) => {
    try {
      return new Address(
        data.countryCode,
        data.postcode,
        data.address1,
        data.address2,
        data.address3,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const AddressParserV2: IParser<IAddress, AccountDetailsAddress> = {
  toDomain: (data) => {
    try {
      return new Address(
        data.countryCode ?? "",
        data.postcode ?? "",
        data.address1 ?? "",
        data.address2 ?? "",
        data.address3 ?? "",
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
